export const OrderEndpoint = {
    detailedOrder: `${process.env.API_BACKEND}/v1/bookings/booking/`,
    order: `${process.env.API_BACKEND}/v1/bookings/order/`,
    bookings: `${process.env.API_BACKEND}/v1/bookings/order/booking/`,
    payment: `${process.env.API_BACKEND}/v1/payments/order/get_payment_url`,
} as const
